import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-unauthorized-dialog',
  templateUrl: './unauthorized-dialog.component.html',
  styleUrls: ['./unauthorized-dialog.component.scss'],
})
export class UnauthorizedDialogComponent {
  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<UnauthorizedDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  onClose() {
    this.dialogRef.close(true);
  }
}
